import React from "react";
import HandleWorkflowReminder from "../../Workflow/HandleWorkflowReminder";
import HandleReminder from "./HandleReminder";
import { ReminderContextProvider } from "./ReminderContextProvider";

const ReminderHandler = ({ isNew, onClick, show, anchor, setShowReminder, isTaskReminder, toggleShowPopup, setShowPopup }) => {
  return (
    <>
      <ReminderContextProvider>
        {isTaskReminder ? (
          <HandleReminder isNew={isNew} onClick={onClick} show={show} anchor={anchor} setShowReminder={setShowReminder} />
        ) : (
          <HandleWorkflowReminder show={show} anchor={anchor} toggleShowPopup={toggleShowPopup} setShowPopup={setShowPopup} onClick={onClick} />
        )}
      </ReminderContextProvider>
    </>
  );
};

export default ReminderHandler;
